import {ensureErrorType} from "@2d-front-monorepo/core";
import React from "react";
import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router";
import Application from "./Application";
import {reportError} from "./functions";

createRoot(document.getElementById('root') as HTMLElement, {
	onUncaughtError: (e) => reportError(ensureErrorType(e))
}).render(
	<React.StrictMode>
		<BrowserRouter>
			<Application/>
		</BrowserRouter>
	</React.StrictMode>
);
